<template>
<div>
    <b-modal id="matterCriminalComplaintFormModal" ref="matterCriminalComplaintFormModal" centered size="lg" no-close-on-backdrop :title="$t('matterCriminalComplaint.info')" :cancel-title="$t('others.cancel_title')" :ok-title="$t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate()">
        <b-card>
            <!-- Koşulsuz alanlar -->
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterCriminalComplaint.authority') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawAuthoritySelect" value-field="id" text-field="name" :options="lawAuthorityOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterCriminalComplaint.subject') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawMatterSubjectSelect" value-field="id" text-field="name" :options="lawMatterSubjectOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterCriminalComplaint.sub_subject') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawMatterSubSubjectSelect" value-field="id" text-field="name" :options="lawMatterSubSubjectOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterCriminalComplaint.is_search_and_seizure_requested') }}</label>
                        <b-form-group>
                            <b-form-checkbox v-model="isSearchAndSeizureRequested" class="mt-50" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label for="matter-criminal-complaint-investigation-no-input">{{ $t('matterCriminalComplaint.investigation_no') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" id="matter-criminal-complaint-investigation-no-input" v-model="investigationNo" maxlength="20" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterCriminalComplaint.complaint_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" placeholder="" size="sm" v-model="complaintDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterCriminalComplaint.process_result') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawMatterProcessResultSelect" value-field="id" text-field="name" :options="lawMatterProcessResultOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>

            <!-- "Soruşturma" seçilince görünen alanlar -->
            <template v-if="isSorusturma">
                <b-row>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label>{{ $t('matterCriminalComplaint.counter_party') }}</label>
                            <b-form-group>
                                <b-form-select size="sm" v-model="lawCounterPartySelect" value-field="id" text-field="name" :options="lawCounterPartyOption" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label>{{ $t('matterCriminalComplaint.court') }}</label>
                            <b-form-group>
                                <b-form-select size="sm" v-model="lawCourtSelect" value-field="id" text-field="name" :options="lawCourtOption" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label>{{ $t('matterCriminalComplaint.decision_date') }}</label>
                            <b-form-group>
                                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" placeholder="" size="sm" v-model="decisionDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label>{{ $t('matterCriminalComplaint.dispatch_date_to_expert') }}</label>
                            <b-form-group>
                                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" placeholder="" size="sm" v-model="originalProductDispatchDateToExpert" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label>{{ $t('matterCriminalComplaint.product_return_date') }}</label>
                            <b-form-group>
                                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" placeholder="" size="sm" v-model="originalProductReturnDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-criminal-complaint-case-no-input">{{ $t('matterCriminalComplaint.case_no') }}</label>
                            <b-form-group>
                                <b-form-input size="sm" id="matter-criminal-complaint-case-no-input" v-model="caseNo" maxlength="50" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-criminal-complaint-indictment-no-input">{{ $t('matterCriminalComplaint.indictment_no') }}</label>
                            <b-form-group>
                                <b-form-input size="sm" id="matter-criminal-complaint-indictment-no-input" v-model="indictmentNo" maxlength="50" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label>{{ $t('matterCriminalComplaint.indictment_date') }}</label>
                            <b-form-group>
                                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" placeholder="" size="sm" v-model="indictmentDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
            </template>
        </b-card>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            lawMatterId: 0,
            lawAuthoritySelect: 0,
            lawAuthorityOption: [],
            lawCounterPartySelect: 0,
            lawCounterPartyOption: [],
            lawCourtSelect: 0,
            lawCourtOption: [],
            lawMatterSubjectSelect: 0,
            lawMatterSubjectOption: [],
            lawMatterSubSubjectSelect: 0,
            lawMatterSubSubjectOption: [],
            lawMatterProcessResultSelect: 0,
            lawMatterProcessResultOption: [],
            complaintDate: null,
            isSearchAndSeizureRequested: false,
            investigationNo: '',
            decisionDate: null,
            originalProductDispatchDateToExpert: null,
            originalProductReturnDate: null,
            indictmentNo: '',
            indictmentDate: null,
            caseNo: '',
        }
    },
    computed: {
        isSorusturma() {
            const selected = this.lawMatterProcessResultOption.find(o => o.id === this.lawMatterProcessResultSelect)
            return selected && selected.name === 'Soruşturma'
        }
    },
    methods: {
        showCriminalComplaint(id, lawMatterId) {
            this.$refs['matterCriminalComplaintFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId
            const data = { id: this.id }
            const controller = { name: 'LawMatterCriminalComplaint' }
            const payload = { data: data, controller: controller }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    const record = response.data.lawMatterCriminalComplaint

                    this.lawAuthorityOption = response.data.lawAuthorityList
                    this.lawAuthorityOption.splice(0, 0, this.$nullSelected())
                    this.lawAuthoritySelect = record.lawAuthorityId

                    this.lawCounterPartyOption = response.data.lawCounterPartyList
                    this.lawCounterPartyOption.splice(0, 0, this.$nullSelected())
                    this.lawCounterPartySelect = record.lawCounterPartyId

                    this.lawCourtOption = response.data.lawCourtList
                    this.lawCourtOption.splice(0, 0, this.$nullSelected())
                    this.lawCourtSelect = record.lawCourtId

                    this.lawMatterSubjectOption = response.data.lawMatterSubjectList
                    this.lawMatterSubjectOption.splice(0, 0, this.$nullSelected())
                    this.lawMatterSubjectSelect = record.lawMatterSubjectId

                    this.lawMatterSubSubjectOption = response.data.lawMatterSubSubjectList
                    this.lawMatterSubSubjectOption.splice(0, 0, this.$nullSelected())
                    this.lawMatterSubSubjectSelect = record.lawMatterSubSubjectId

                    this.lawMatterProcessResultOption = response.data.lawMatterProcessResultList
                    this.lawMatterProcessResultOption.splice(0, 0, this.$nullSelected())
                    this.lawMatterProcessResultSelect = record.lawMatterProcessResultId

                    this.complaintDate = record.complaintDate
                    this.isSearchAndSeizureRequested = record.isSearchAndSeizureRequested
                    this.investigationNo = record.investigationNo
                    this.decisionDate = record.decisionDate
                    this.originalProductDispatchDateToExpert = record.originalProductDispatchDateToExpert
                    this.originalProductReturnDate = record.originalProductReturnDate
                    this.indictmentNo = record.indictmentNo
                    this.indictmentDate = record.indictmentDate
                    this.caseNo = record.caseNo
                } else {
                    this.$bvModal.hide('matterCriminalComplaintFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        async addOrUpdate() {
            const data = {
                id: this.id,
                lawMatterId: this.lawMatterId,
                lawAuthorityId: this.lawAuthoritySelect,
                lawCounterPartyId: this.lawCounterPartySelect,
                lawCourtId: this.lawCourtSelect,
                lawMatterSubjectId: this.lawMatterSubjectSelect,
                lawMatterSubSubjectId: this.lawMatterSubSubjectSelect,
                lawMatterProcessResultId: this.lawMatterProcessResultSelect,
                complaintDate: this.complaintDate,
                isSearchAndSeizureRequested: this.isSearchAndSeizureRequested,
                investigationNo: this.investigationNo,
                decisionDate: this.decisionDate,
                originalProductDispatchDateToExpert: this.originalProductDispatchDateToExpert,
                originalProductReturnDate: this.originalProductReturnDate,
                indictmentNo: this.indictmentNo,
                indictmentDate: this.indictmentDate,
                caseNo: this.caseNo,
            }
            const controller = { name: 'LawMatterCriminalComplaint' }
            const payload = { data: data, controller: controller }
            var response = await this.$store.dispatch('moduleAuth/save', payload)
            if (response.data.resultStatus == true) {
                if (!this.id) {
                    this.id = response.data.id
                    await this.$SaveLawMatterMatterTypeHistory(18, this.id, this.lawMatterId, this.employeeId)
                    this.getMatterTypeHistoryList()
                }
                this.$bvModal.hide('matterCriminalComplaintFormModal')
                this.$SaveAlert()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
